import { REDUCER_KEY_FIND_PREPARATIONS_SIMILARITY_SEARCH } from './constants';

export const findPreparationsSimilaritySearch = (state) => state.get(REDUCER_KEY_FIND_PREPARATIONS_SIMILARITY_SEARCH);

export const isSimilarityLoading = (state) => findPreparationsSimilaritySearch(state).isSimilarityLoading;

export const isResultsLoading = (state) => findPreparationsSimilaritySearch(state).isResultsLoading;

export const resultPayload = (state) => findPreparationsSimilaritySearch(state).resultPayload;

export const reactions = (state) => findPreparationsSimilaritySearch(state).reactions;

export const totalItems = (state) => findPreparationsSimilaritySearch(state).totalItems;

export const error = (state) => findPreparationsSimilaritySearch(state).error;

export const databaseId = (state) => {
  const result = resultPayload(state);
  return result && result.databaseId;
};
